import { useEffect, useState } from 'react'
import useOfferMetaData from 'hooks/Offers/useOfferMetaData'
import OfferDescription from './OfferDescription'

const TIMEOUT_DURATION = 10000

interface Props {
  filters: App.OfferListFilters
  offerId: string
  className?: string
}

function OfferDescriptionContainer({ filters, offerId, className }: Props) {
  const [showError, setShowError] = useState(false)

  const offerMetaData = useOfferMetaData(offerId, filters)

  // Reset error state when offerId changes
  useEffect(() => {
    setShowError(false)
  }, [offerId])

  // 10 second timeout
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!offerMetaData?.description) {
        setShowError(true)
      }
    }, TIMEOUT_DURATION)

    return () => clearTimeout(timer)
  }, [offerMetaData])

  const hasDescription = offerMetaData?.description && offerMetaData.description.length > 0
  const isLoading = !offerMetaData || !hasDescription

  // Show error message if timed out
  if (showError && !hasDescription) {
    return null
  }

  return (
    <OfferDescription
      description={offerMetaData?.description}
      isLoading={isLoading}
      className={className}
    />
  )
}

export default OfferDescriptionContainer
